import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration settings

/**
 * Class representing a view for managing machine sub-providers.
 */
export default class tableMachineSubProviderView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        // Configuration for the double list component
        var list1 = {
            view: 'dbllist',
            id: 'dbllist',
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Sub Proveedores no agregados'), // Left label
            labelRight: _('Sub Proveedores Agregados'), // Right label
            data: [], // Initial data for the list
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'f1',
            rows: [
                {
                    view: 'forminput',
                    name: 'access', // Input name
                    body: list1, // Body of the input
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Label alignment
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user parameter
        var values = ''; // Variable to store provider values

        // Event listener for filtering machine sub-providers
        this.on(this.app, 'machineSubProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request

            // Loop through filter data to build query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear the double list and fetch new data
            $$('dbllist').$$('left').clearAll();
            $$('dbllist').setValue([]);
            webix.ajax().get(
                devConfig.geturlApi() + 'MachineSubProviders/GetGroupMachineSubProviders', // API endpoint
                string1, // Query string
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            $$('dbllist').$$('left').clearAll(); // Clear left list
                            $$('dbllist').setValue([]); // Reset selected values
                            $$('dbllist').parse(data.Data.ExcludedProvidersList); // Populate excluded providers
                            $$('dbllist').setValue(data.Data.IncludedProvidersList); // Set included providers
                            values = data.Data.IncludedProvidersList; // Store included providers
                        } else {
                            webix.message('Error! '); // Error message
                        }
                    },
                },
            );
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split current values
            var array2 = $$('dbllist').getValue().split(','); // Split new values
            var arrayAgregados = []; // Array for added providers
            var arrayEliminados = []; // Array for removed providers

            // Determine added providers
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if provider was previously included
                });
                if (found == undefined) {
                    arrayAgregados.push(obj); // Add to added providers
                }
            });

            // Determine removed providers
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if provider is still included
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Add to removed providers
                }
            });

            values = $$('dbllist').getValue(); // Update stored values
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for request
                })
                .post(
                    devConfig.geturlApi() + 'MachineSubProviders/SaveGroupMachineSubProviders', // API endpoint for saving
                    '{"IdMachine":"' +
                        cur_user +
                        '","IncludedProvidersList":"' +
                        arrayAgregados +
                        '","ExcludedProvidersList":"' +
                        arrayEliminados +
                        '"}', // Request body
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                webix.message(_('Sub Proveedor Máquina Editado')); // Success message
                            } else {
                                webix.message(_('Error! ')); // Error message
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
